export default __webpack_public_path__ + "assets/models/aec2442e73d93a2bf23860c3720f74e0.glb";